// src/components/misc/HomeIconButton.jsx
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import { HomeIcon } from "@heroicons/react/24/solid";

export default function HomeIconButton() {
  const navigate = useNavigate();
  const { t, isRTL } = useContext(LanguageContext);

  return (
    <button
      onClick={() => navigate("/")}
      title={t("common.go_home")}
      className="
        inline-flex items-center gap-1.5
        h-9 px-3
        rounded-md
       
        border border-gray-200 dark:border-gray-700
        text-gray-700 dark:text-gray-300
        hover:bg-gray-50 dark:hover:bg-gray-800
        transition
      "
    >
      <HomeIcon className="w-4 h-4 text-blue-600 dark:text-blue-400" />

      {/* Texte optionnel (desktop only) */}
      <span
        className={`
          hidden sm:inline text-sm font-medium
          ${isRTL ? "order-first ml-1" : "order-last"}
        `}
      >
        {t("common.home")}
      </span>
    </button>
  );
}
